import endpoints from './api.js';
import BaseLoader from 'fallco-frontend-framework/src/vue/plugins/BaseLoader/BaseLoader.vue'
import {createApp} from "vue";


function isLoading(params) {
  return (!params || (params && params['settings'] != undefined && ("loading" in params.settings) && params.settings.loading) || (params && params['settings'] != undefined && !("loading" in params.settings)));
}

function createHttpLoader() {
  const loaderEl = document.createElement('div')
  const loader = createApp(BaseLoader, {});
  const loaderMount = loader.mount(loaderEl);
  loaderMount.show();

  return {
    app: loader,
    mount: loaderMount
  }
}

function destroyHttpLoader(loader) {
  loader.mount.hide();
  loader.app.unmount();
}
/**
 * Indirizzi la richiesta al corretto file di endpoint.
 * Se non trova l'endpoint logga un errore in console.
 * @param params
 * @param callback
 * @returns {Promise<*>}
 */
const endpointSwitcher = async (params, callback = null) =>
{
  if(!endpoints[params.modules][params.endpoint] && params.endpoint != 'downloadFile') {
    console.error('Endpoint Non Trovato: '+ params.modules + ' ' + params.endpoint);
  }else {
    let response;
    let loading = null

    if(isLoading(params)) {
      loading = createHttpLoader();
    }

    try{
      response = await endpoints[params.modules][params.endpoint](params.settings, params.data, callback);
    }catch(error) {
      console.log("error", error)
      response = {data: error.response.data};
    }

    if(isLoading(params)) {
      destroyHttpLoader(loading)
    }

    if(params.settings && params.settings['responseType'] != undefined && params.settings['responseType'] === 'blob') {
      // filename
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'unknown';
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length === 2)
          fileName = fileNameMatch[1];
      }
      // url
      const blob = new Blob([response.data], {type: response.data.type});
      const url = window.URL.createObjectURL(blob);
      let origin = window.location.origin;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }

    return response.data;
  }
}

/**
 *
 * @param module
 * @param action
 * @param settings
 * @param params
 * @param callback
 * @returns {Promise<*>}
 */
export function httpPost (module, action, params, settings = {}, callback) {
  settings['method'] = 'POST';
  return endpointSwitcher({modules: module, endpoint: action, settings: settings, data: params}, callback)
}

export function httpGet (module, action, params, settings = {}, callback)  {
  settings['method'] = 'GET';
  return endpointSwitcher({modules: module, endpoint: action, settings: settings, data: params}, callback)
}

export function httpDownloadFile(module, action, params, settings = {}, callback) {
  settings['method'] = 'GET';
  settings['responseType'] = 'blob';
  return endpointSwitcher({modules: module, endpoint: action, settings: settings, data: params}, callback)
}